/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import {PureComponent} from 'react';
import {connect} from 'react-redux';

import {showNotification} from 'Store/Notification/Notification.action';
import {showPopup} from 'Store/Popup/Popup.action';

import FashionPopup from './FashionPopup.component';
import {FASHION_POPUP_ID, FASHION_POPUP_BROWSER_ITEM} from "./FashionPopup.config";
import BrowserDatabase from 'Util/BrowserDatabase/BrowserDatabase';
import {WebsiteSwitch} from "@mageguide/website-switch/src/plugin/HeaderContainer.plugin";

/** @namespace Component/FashionPopup/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    showNotification: (message) => dispatch(showNotification('success', message)),
    showError: (message) => dispatch(showNotification('error', message)),
    showPopup: (payload) => dispatch(showPopup(FASHION_POPUP_ID, payload)),
    switchWebsite: (options) => WebsiteSwitch.then(
        ({ default: dispatcher }) => dispatcher.switchWebsite(options, dispatch)
    ),
    hidePopup: () => dispatch(showPopup('', {}))
});

/** @namespace Component/FashionPopup/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    blocks: state.CmsBlocksAndSliderReducer.blocks,
    isFashion: state.switchWebsiteReducer.isFashion
});

/** @namespace Component/FashionPopup/Container/FashionPopupContainer */
export class FashionPopupContainer extends PureComponent {
    static propTypes = {
        showError: PropTypes.func.isRequired,
        showPopup: PropTypes.func.isRequired,
        hidePopup: PropTypes.func.isRequired,
        showNotification: PropTypes.func.isRequired
    };

    static defaultProps = {
        showCallButton: false
    };

    containerFunctions = {
        openFashionPopup: this.openFashionPopup.bind(this)
    };

    containerProps() {
        const {showCallButton, blocks, switchWebsite} = this.props;

        return {showCallButton, blocks, switchWebsite};
    }

    openFashionPopup() {
        const { isFashion, showPopup } = this.props;

        if(!isFashion && !BrowserDatabase.getItem(FASHION_POPUP_BROWSER_ITEM)){
            setTimeout(function(){
                showPopup();
            }, 2000);
        }
    }

    render() {
        return (
            <FashionPopup
                {...this.containerProps()}
                {...this.containerFunctions}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FashionPopupContainer);
